import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col, Table, Input, Select, Tag } from 'antd';
import AdminLayout from './AdminLayout';
import * as actions from './redux/actions';
import * as actionsUser from '../user/redux/actions';
import API, { CSV_URL } from '../../helper/api/Api';
import _ from 'lodash';
const Option = Select.Option;

const columns = [{
  title: 'Nom',
  dataIndex: 'lastName',
}, {
  title: 'Prénom',
  dataIndex: 'firstName',
}, {
  title: 'Classe',
  render: (i, record) => {
    return (<Tag>{record.promotion.name}</Tag>)
  },
}, {
  title: 'Email',
  dataIndex: 'email',
}, {
  title: 'Promo',
  render: (i, record) => {
    const color = record.promotion.year === "N/A" ? null : 'blue';

    return (<Tag color={color}>{record.promotion.year}</Tag>)
  }
}, {
  title: 'Point jury',
  dataIndex: 'totalJuryPoints',
}, {
  title: 'Status',
  render: (i, record) => {
    const color = record.role.name === "Admin" ? 'magenta' : 'blue';

    return (<Tag color={color}>{record.role.name}</Tag>)
  }
}, {
  title: 'Participation',
  dataIndex: 'participation',
}];

export class Users extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    search: null,
    selectedRowKeys: [],
    selected_users: [],
    classes: [], 
    promo: []
  }

  componentDidMount() {
    this.props.actions.getUsers();
  }

  toLowerCase(str) {
    return str.toLowerCase();
  }

  render() {
    const users = JSON.parse(JSON.stringify(this.props.user.list));

    return (
      <AdminLayout
        title="UTILISATEURS"
        buttons={
          [{
            icon: "download",
            name: "EXPORTER",
            disabled: this.state.selected_users.length === 0,
            onClick: () => API.post('/user/export/' + this.state.selected_users.map(u => u.id).join(','))
              .then((res) => window.open(CSV_URL(res.data)))
              //.then(() => this.setState({ selected_users : [], selectedRowKeys: [] }))
          }]
        }
      >
        <Row style={{ margin: '20px 0' }}>
          <Row gutter={16}>
            <Col span={24}>
              <Input
                placeholder="Rechercher un utilisateur"
                value={this.state.search}
                onChange={(e) => this.setState({ search: this.toLowerCase(e.target.value) })}
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12} style={{ margin: '10px 0' }} xs={{ span: 24 }} md={{ span: 12 }}>
              <Select 
                placeholder="Classes"
                mode="multiple"
                value={this.state.classes}
                onChange={(select) => this.setState({ classes: select })}
                style={{ width: '100%' }} >
                {
                  [...new Set(
                    users
                      .map((user) => user.promotion.name)
                  )].map(name => <Option value={name}>{name}</Option>)
                }
              </Select>
            </Col>
            <Col  span={12} style={{ margin: '10px 0' }} xs={{ span: 24 }} md={{ span: 12 }}>
              <Select 
                placeholder="Promotions" 
                mode="multiple"
                value={this.state.promo}
                onChange={(promo) => this.setState({ promo })}
                style={{ width: '100%' }} >
              {
                  [...new Set(
                    users
                      //.filter((user) => this.state.classes.includes(user.promotion.name))
                      .map((user) => user.promotion.year)
                  )].map(year => <Option value={year}>{year}</Option>)
                }
              </Select>
            </Col>
          </Row>
        </Row>
        <Row style={{ margin: '30px 0 0 0x' }}>
          <Table
            loading={{ size: "small", spinning: this.props.user.status.getUsers.pending}}
            onRow={(record) => ({
                onClick: () => this.props.history.push('/admin/users/'+record.id),
                style: {cursor: 'pointer'}
              })
            }
            rowSelection={{
              selectedRowKeys: this.state.selectedRowKeys,
              onChange: (selectedRowKeys, selectedRows) => {
                this.setState({ selected_users : selectedRows, selectedRowKeys });
              },
              getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
              }),
            }}
            pagination={{
              defaultPageSize: 20
            }}
            columns={columns}
            dataSource={ _.sortBy(users, ['lastName']).filter(u =>
              (!this.state.search ||
              u.lastName.toLowerCase().includes(this.state.search)
              || u.firstName.toLowerCase().includes(this.state.search)
              || u.email.toLowerCase().includes(this.state.search))
              && (
                this.state.classes.length === 0 || this.state.classes.includes(u.promotion.name)
                && this.state.promo.length === 0 || this.state.promo.includes(u.promotion.year)
              )
            )} />
        </Row>
      </AdminLayout>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...actionsUser }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);



// WEBPACK FOOTER //
// ./src/features/admin/Users.js